var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "no-ssr-loader",
    [
      _c(
        "b-container",
        { staticClass: "py-5" },
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { cols: "12", md: "8" } }, [
                _c("h1", { staticClass: "mb-3" }, [
                  _vm._v("\n          Product Catalogues\n        "),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-button",
                    { attrs: { variant: "primary", to: "/catalogues/new" } },
                    [_vm._v("\n          Create Product Catalogue\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  !_vm.errorLoading
                    ? _c("catalogues-table")
                    : _c(
                        "div",
                        { staticClass: "text-center py-5" },
                        [
                          _c("b-icon", {
                            staticClass: "h2",
                            attrs: {
                              icon: "exclamation-triangle",
                              large: "",
                              variant: "danger",
                            },
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(
                              "An error occurred while attempting to load the product catalogues."
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.retryAttempted,
                                variant: "primary",
                              },
                              on: { click: _vm.retry },
                            },
                            [_vm._v("\n            Retry\n          ")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }